module.exports = __webpack_public_path__ + "static/img/textchecker-logo-v1.573cfb0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/textchecker-logo-v1.png
// module id = F0dy
// module chunks = 8